// extracted by mini-css-extract-plugin
export default {"card":"UserCard_card__PgOJW","editButton":"UserCard_editButton__jYPH5","deleteButton":"UserCard_deleteButton__boeMw"};